import Api from "./api";

class AddressService extends Api {}

export default new AddressService({
  ressource: "addresses"
});
